import React from 'react'
import {ReactComponent as PlayIcon} from '../svgs/play.svg';
import {Link} from 'react-router-dom'

const Playlists = (props) => {
  console.log(props.limiter)
  const dataPlaylists =[
    {
      id: 101,
      category_id: 3,
      name: 'Home playlist 1',
      img: 'https://images.unsplash.com/photo-1696347284654-b952434231e0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwxMTl8fHxlbnwwfHx8fHw%3D&auto=format&fit=crop&w=900&q=60',
      desc:'Lorem ipsum'
    },
    {
       id: 102,
      category_id: 3,
      name: 'Home playlist 2',
      img:'https://images.unsplash.com/photo-1696253930743-e2977a17dd59?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHw1MHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=900&q=60',
      desc:'Lorem ipsum'
    },
    {
      id: 101,
      category_id: 3,
      name: 'Home playlist 1',
      img: 'https://images.unsplash.com/photo-1696347284654-b952434231e0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwxMTl8fHxlbnwwfHx8fHw%3D&auto=format&fit=crop&w=900&q=60',
      desc:'Lorem ipsum'
    },
    { 
      id: 102,
      category_id: 3,
      name: 'Home playlist 2',
      img:'https://images.unsplash.com/photo-1696253930743-e2977a17dd59?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHw1MHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=900&q=60',
      desc:'Lorem ipsum'
    },

    {
      id: 102,
      category_id: 3,
      name: 'Home playlist 2',
      img:'https://images.unsplash.com/photo-1696253930743-e2977a17dd59?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHw1MHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=900&q=60',
      desc:'Lorem ipsum'
    },

    {
      id: 103,
      category_id: 3,
      name: 'Home playlist 3',
      img:'https://media.istockphoto.com/id/1571575345/photo/young-happy-woman-having-fun-while-dancing-on-a-music-festival-at-sunset.webp?b=1&s=170667a&w=0&k=20&c=WAuwT5DYBM9HgqTVQ9MW18Qm0CnD3d9uUzBjQQCNjaE=',
      desc:'Lorem ipsum'
    },
    {
      id: 103,
      category_id: 3,
      name: 'Home playlist 3',
      img:'https://media.istockphoto.com/id/1571575345/photo/young-happy-woman-having-fun-while-dancing-on-a-music-festival-at-sunset.webp?b=1&s=170667a&w=0&k=20&c=WAuwT5DYBM9HgqTVQ9MW18Qm0CnD3d9uUzBjQQCNjaE=',
      desc:'Lorem ipsum'
    },
    {
      id: 103,
      category_id: 3,
      name: 'Home playlist 3',
      img:'https://media.istockphoto.com/id/1571575345/photo/young-happy-woman-having-fun-while-dancing-on-a-music-festival-at-sunset.webp?b=1&s=170667a&w=0&k=20&c=WAuwT5DYBM9HgqTVQ9MW18Qm0CnD3d9uUzBjQQCNjaE=',
      desc:'Lorem ipsum'
    },

    {
      id: 104,
      category_id: 1,
      name: 'Home playlist 3',
      img: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8bXVzaWN8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=900&q=60',
      desc:'Lorem ipsum'
    },

    {
      id: 105,
      category_id: 4,
      name: 'Sunday playlists',
      img:'https://images.unsplash.com/photo-1617720197345-5e5235ec6220?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTh8fHBlYWNlfGVufDB8fDB8fHww&auto=format&fit=crop&w=900&q=60',
      desc:'Lorem ipsum'
    },
    {
      id: 105,
      category_id: 4,
      name: 'Sunday playlists',
      img:'https://images.unsplash.com/photo-1696484863977-7f7feb9a2adf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHw2MHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=900&q=60',
      desc:'Lorem ipsum'
    },
    {
      id: 105,
      category_id: 4,
      name: 'Sunday playlists',
      img:'https://images.unsplash.com/photo-1696484863977-7f7feb9a2adf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHw2MHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=900&q=60',
      desc:'Lorem ipsum'
    },

    {
      id: 106,
      category_id: 2,
      name: 'Mood playlists 1',
      img: 'https://images.unsplash.com/photo-1683009427500-71296178737f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDF8MHxlZGl0b3JpYWwtZmVlZHw5MXx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=900&q=60',
      desc:'Lorem ipsum'
    },
    {
      id: 107,
      category_id: 2,
      name: 'Mood playlists 2',
      img: 'https://images.unsplash.com/photo-1696351616794-79346a9be3c1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwxMDN8fHxlbnwwfHx8fHw%3D&auto=format&fit=crop&w=900&q=60',
      desc:'Lorem ipsum'
    },
    {
      id: 106,
      category_id: 2,
      name: 'Mood playlists 1',
      img: 'https://images.unsplash.com/photo-1683009427500-71296178737f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDF8MHxlZGl0b3JpYWwtZmVlZHw5MXx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=900&q=60',
      desc:'Lorem ipsum'
    },

    

    {
      id: 107,
      category_id: 2,
      name: 'Mood playlists 2',
      img: 'https://images.unsplash.com/photo-1696351616794-79346a9be3c1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwxMDN8fHxlbnwwfHx8fHw%3D&auto=format&fit=crop&w=900&q=60',
      desc:'Lorem ipsum'
    },

    {
      id: 107,
      category_id: 2,
      name: 'Mood playlists 2',
      img: 'https://images.unsplash.com/photo-1696351616794-79346a9be3c1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwxMDN8fHxlbnwwfHx8fHw%3D&auto=format&fit=crop&w=900&q=60',
      desc:'Lorem ipsum'
    },
  ]

  // another object 
  let matchedPlaylists = dataPlaylists.filter(playlist =>playlist.category_id === props.category_id) 
  .slice(0, props.limiter)

  // anytime u use a map u need to put a key in the element
  return(
    <div className="cardsWrapperInner">
     { matchedPlaylists.map((playlist , id)=>(
      <Link to={'/playlist/' + playlist.id}>
       <div className="card" key={id}>
       <div className="cardImage">
       <img src={playlist.img} />
       </div>
 
       <div className="cardContent"><h3>{playlist.name}</h3>
       <span>{playlist.desc}</span>
       </div>
       <span className="playIcon">
      <PlayIcon />
       </span>
     </div>
     </Link>
      ))}
    </div>
  );
}

export default Playlists;